import Image from "next/legacy/image";
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import dynamic from 'next/dynamic';
const BrowserOnly = dynamic(()=> import( '../../shared/BrowserOnly'), {
  ssr: false,
})

const GNOTrainingBanner: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-10 bg-center bg-no-repeat bg-cover w-100 bg-explore-banner-with-gradient">
      <p className="my-2 text-lg italic text-center text-green font-heading md:text-2xl">
        Ready for a new career?
      </p>
      <h1 className="px-4 text-2xl font-bold text-center text-green font-heading md:px-0 md:text-4xl">
        Find a great training program today.
      </h1>
      {/* Swiper works better when it only runs in the browser
      so if we wrap it in <BrowserOnly> it will function as expected.
    */}
      <BrowserOnly>
        <Swiper
          direction="horizontal"
          className="z-0 w-screen mt-10 overflow-hidden md:mt-20"
          modules={[Autoplay]}
          autoplay={{
            delay: 1000,
          }}
          breakpoints={{
            0: {
              slidesPerView: 2.5,
            },
            768: {
              slidesPerView: 5,
            },
          }}
        >
          <SwiperSlide>
            <figure className="flex flex-col">
              <Image
                className="w-16 mx-auto my-2 md:w-20"
                alt="Apprenticeships icon"
                src="https://res.cloudinary.com/wherewego/image/upload/v1647967522/WWG2000%20Site%20Photos/q8cmjimppatwi48snyih.svg"
                layout="responsive"
                loading="eager"
                width={1000}
                height={175}
              />
              <figcaption className="text-base font-bold text-center text-white font-heading">
                Apprenticeships
              </figcaption>
            </figure>
          </SwiperSlide>
          <SwiperSlide>
            <figure className="flex flex-col">
              <Image
                className="w-16 mx-auto my-2 md:w-20"
                alt="Apprenticeships icon"
                src="https://res.cloudinary.com/wherewego/image/upload/v1647967520/WWG2000%20Site%20Photos/v7xqayohkaecimbkdnw7.svg"
                layout="responsive"
                loading="eager"
                width={1000}
                height={175}
              />
              <figcaption className="text-base font-bold text-center text-white font-heading">
                1-2 year Degrees
              </figcaption>
            </figure>
          </SwiperSlide>
          <SwiperSlide>
            <figure className="flex flex-col">
              <Image
                className="w-16 mx-auto my-2 md:w-20"
                alt="Apprenticeships icon"
                src="https://res.cloudinary.com/wherewego/image/upload/v1647967518/WWG2000%20Site%20Photos/gvqylybeo4tmjprgnhq2.svg"
                layout="responsive"
                loading="eager"
                width={1000}
                height={175}
              />
              <figcaption className="text-base font-bold text-center text-white font-heading">
                Bootcamps
              </figcaption>
            </figure>
          </SwiperSlide>
          <SwiperSlide>
            <figure className="flex flex-col">
              <Image
                className="w-16 mx-auto my-2 md:w-20"
                alt="Apprenticeships icon"
                src="https://res.cloudinary.com/wherewego/image/upload/v1647967516/WWG2000%20Site%20Photos/cwqybapgxf4axmb0wie9.svg"
                layout="responsive"
                loading="eager"
                width={1000}
                height={175}
              />
              <figcaption className="text-base font-bold text-center text-white font-heading">
                On-the-Job Training
              </figcaption>
            </figure>
          </SwiperSlide>
          <SwiperSlide>
            <figure className="flex flex-col">
              <Image
                className="w-16 mx-auto my-2 md:w-20"
                alt="Apprenticeships icon"
                src="https://res.cloudinary.com/wherewego/image/upload/v1647967515/WWG2000%20Site%20Photos/p61dlihuqubq8nkyvczm.svg"
                layout="responsive"
                loading="eager"
                width={1000}
                height={175}
              />
              <figcaption className="text-base font-bold text-center text-white font-heading">
                One of a Kind
              </figcaption>
            </figure>
          </SwiperSlide>
        </Swiper>
      </BrowserOnly>
    </div>
  );
};

export default GNOTrainingBanner;
